import React from 'react';
import jsPDF from 'jspdf';
import { saveAs } from 'file-saver';
import { useTranslation } from 'react-i18next';

function ExportControls({ graphRef, pathData }) {
  const { t } = useTranslation();

  const exportAsPDF = () => {
    if (!graphRef?.current) return;

    try {
      const pngData = graphRef.current.getPNGDataURL();
      if (!pngData) { alert(t('export.error_capture')); return; }

      const img = new Image();
      img.onload = () => {
        const pdf = new jsPDF({
          orientation: img.width > img.height ? 'l' : 'p',
          unit: 'mm',
          format: 'a4'
        });

        const pdfWidth  = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const margin    = 10;
        const availW    = pdfWidth  - margin * 2;
        const availH    = pdfHeight - margin * 2 - 12;

        const ratio = Math.min(availW / img.width, availH / img.height);
        const imgW  = img.width  * ratio;
        const imgH  = img.height * ratio;
        const x     = margin + (availW - imgW) / 2;
        const y     = margin + (availH - imgH) / 2;

        pdf.addImage(pngData, 'PNG', x, y, imgW, imgH);
        pdf.setFontSize(9);
        pdf.setTextColor(120);
        pdf.text('Prepify Graph - Relationship Visualization', margin, pdfHeight - 8);
        pdf.text(`Generated: ${new Date().toLocaleString()}`, margin, pdfHeight - 4);
        pdf.save('prepify-graph.pdf');
      };
      img.src = pngData;
    } catch (error) {
      console.error('PDF export error:', error);
      alert(t('export.error_pdf'));
    }
  };

  const exportAsPNG = () => {
    if (!graphRef?.current) return;
    graphRef.current.exportPNG();
  };

  const exportAsJSON = () => {
    if (!pathData) { alert(t('export.no_data')); return; }
    try {
      const exportData = {
        exported_at: new Date().toISOString(),
        paths: pathData.paths,
        graph_stats: {
          total_paths: pathData.count,
          source: pathData.paths[0]?.details[0]?.name || 'Unknown',
          target: pathData.paths[0]?.details[pathData.paths[0].details.length - 1]?.name || 'Unknown'
        }
      };
      const blob = new Blob([JSON.stringify(exportData, null, 2)], { type: 'application/json' });
      saveAs(blob, 'prepify-graph-data.json');
    } catch (error) {
      console.error('JSON export error:', error);
      alert(t('export.error_json'));
    }
  };

  return (
    <div className="export-controls">
      <h3>{t('export.title')}</h3>
      <div className="export-buttons">
        <button onClick={exportAsPDF}  className="export-btn pdf-btn">{t('export.pdf')}</button>
        <button onClick={exportAsPNG}  className="export-btn png-btn">{t('export.png')}</button>
        <button onClick={exportAsJSON} className="export-btn json-btn">{t('export.json')}</button>
      </div>
    </div>
  );
}

export default ExportControls;
